const routes = [
    { name: 'home', path: "home", langKey: "home" },
    { name: 'О нама', path: 'about', langKey: "nav_benefits" },
    { name: 'Функционалности', path: 'function', langKey: "nav_functionalities" },
    { name: 'Примери', path: 'examples', langKey: "nav_examples" },
    // { name: 'Демо', path: 'demo' },
    // { name: 'Рекли су', path: 'results' },
    { name: 'Честа питања', path: 'faq', langKey: "nav_faq" },
]

export default routes